import React from 'react';
import axios from 'axios';
import SellToolItem from './SellToolItem';

import { AuthContext } from '../../context/AuthContext';
import { Spinner } from 'react-bootstrap';
import { set } from '@firebase/database';
import ENDPOINT from '../../data/ENDPOINT';



const SellTools = () => {
  const [tools, setTools] = React.useState([]);
 
  const { user, setCartCount } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);


  const Videos = async () => {
    setLoading(true);
    const data = new FormData();
    const response = await axios.post(
      `${ENDPOINT}get-sell-tools.php`,
      data,
      { "header": { "content-type": "multipart/formdata" } }
    );
    if (response) {
      if (response.data.status === "success"){
        setTools(response.data.data);
        setLoading(false);
      }
      else {
        alert("error");
      }
    }
  };

  const fetchCartCount = React.useCallback(async () => {

    setCartCount(0);
    if(user == null || user == 'null'){
      
        return;
    }
    const data = new FormData();
    if(user !== null || user !== 'null'){
        data.append("session", user.SessionId);
    }
    const response = await axios.post(
      `${ENDPOINT}sell-tool-user-carts.php`,
      data,
      { "header": { "content-type": "multipart/formdata" } }
    );
    if (response && response.data.status === "success") {

      const arr = Array.isArray(response.data.data) ? response.data.data : [];
      setCartCount(arr.length);
    }
  }, [user, setCartCount]);

  const memoizedToolItems = React.useMemo(() => (
    tools && tools.length > 0
      ? tools.map((item) => (
          <SellToolItem
            key={item.tool_id}
            item={item}
            onCartUpdate={fetchCartCount}
          />
        ))
      : null
  ), [tools, fetchCartCount]);

  React.useEffect(() => {
    Videos();
    fetchCartCount();
    
  }, []);


  if (loading) {
    return <div className="text-center my-4"><Spinner animation="border" /></div>;
  }

  return (
    <div>
      <div className="container-fluid container-md container-lg container-xl position-relative min-vh-90">
      

        <div className='d-flex mt-3  flex-wrap'>
          {memoizedToolItems}
        </div>
      </div>
    </div>
  );
}

export default SellTools;
